import {
  type Option,
  PillGroup,
  SelectField,
} from "@/components/tool-kit/primitives";
import type {
  GridAlphabet,
  SquareFill,
} from "@/lib/tool-kit/ciphers-polygraphic/squares";

/*
 * The two choices every Polybius-square cipher shares: how the square holds its letters
 * (I and J together, Q left out, or 6 × 6 with digits) and the route a keyword is written
 * into it. Vocabulary-free — every word arrives in props.
 */

export interface SquareOptionsProps {
  idPrefix: string;
  kindLabel: string;
  kinds: readonly Option<GridAlphabet>[];
  kind: GridAlphabet;
  onKindChange: (kind: GridAlphabet) => void;
  fillLabel: string;
  fillHint: string;
  fills: readonly Option<SquareFill>[];
  fill: SquareFill;
  onFillChange: (fill: SquareFill) => void;
}

export function SquareOptions({
  idPrefix,
  kindLabel,
  kinds,
  kind,
  onKindChange,
  fillLabel,
  fillHint,
  fills,
  fill,
  onFillChange,
}: SquareOptionsProps) {
  return (
    <>
      <PillGroup
        label={kindLabel}
        name={`${idPrefix}-kind`}
        onChange={onKindChange}
        options={kinds}
        value={kind}
      />
      <SelectField
        hint={fillHint}
        id={`${idPrefix}-fill`}
        label={fillLabel}
        onChange={onFillChange}
        options={fills}
        value={fill}
      />
    </>
  );
}
